// extracted by mini-css-extract-plugin
module.exports = {"donations":"Donations_donations__1rAMe","header":"Donations_header__Ykt_t","donationButton":"Donations_donationButton__c-rYe"};